// MUI
import { Grid2, LinearProgress } from "@mui/material";
// styles
import styles from "./LicenceCard.module.scss";
import { planIcon } from "../../../../../../Utils/planIcons";
import { useNavigate } from "react-router-dom";

export default function LicenceCard(props) {
  const { basePlan, numSitesFeature, orgId, isParentOrg } = props;
  const navigate = useNavigate();

  const planName = basePlan?.licenseType;
  const singleSite = basePlan?.isSingleSite;
  const PlanIcon = planName && planIcon[planName];
  // Base Paln
  const used = numSitesFeature?.used;
  const limits = numSitesFeature?.limitOrAvailablity;
  const isLimitReached = limits === used;
  const basePlanValue = (used / limits) * 100;

  return (
    <>
      <Grid2 className={styles.LicenceCardContainer}>
        <Grid2 className={styles.Icon}>
          {planName && PlanIcon ? <PlanIcon className={styles.PlanIcon} /> : null}
        </Grid2>
        <Grid2 className={styles.linearProgress}>
          <Grid2 className={styles.Flexbox}>
            <Grid2 className={styles.planName}>
              {(singleSite ? "SS-" : "MS-") + planName}
            </Grid2>
            {(orgId === -1 || isParentOrg === null) && (
              <Grid2
                className={styles.UpdatePlan}
                onClick={() => {
                  navigate(`/account/${orgId}/modify-plan`);
                }}
              >
                {planName === "Booster" ? "" : "Upgrade Plan"}
              </Grid2>
            )}
          </Grid2>

          <Grid2 className={styles.isLimitReached}>
            <Grid2 className={styles.FlexboxlinearProgress}>
              <Grid2 className={styles.Flexbox}>
                <Grid2 className={styles.sitesCount}>
                  Total Number of Sites ({limits})
                </Grid2>
                <Grid2
                  className={`${
                    isLimitReached ? styles.usedCount : styles.usedColor
                  }`}
                >
                  {used} used
                </Grid2>
              </Grid2>
              <Grid2
                className={`${styles.linearProgress} ${
                  isLimitReached ? styles.width50 : ""
                }`}
              >
                <LinearProgress
                  variant="determinate"
                  value={basePlanValue}
                  sx={{
                    width: "100%",
                    height: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#ccc",
                    "& .MuiLinearProgress-bar": {
                      background: isLimitReached
                        ? "linear-gradient(90deg, #E5B0B0 -3.88%, #EE0126 100%);"
                        : "linear-gradient(90deg, #135FC2 -3.88%, #EE3938 168.99%)",
                    },
                    "@media (min-width: 1800px)": {
                      height: "7px",
                    },
                  }}
                />
              </Grid2>
            </Grid2>
            {/* {isLimitReached && (
              <>
                {additionalSite.quantity === 0 ? (
                  <Grid2 className={styles.AdditionalButton}>
                    Buy Additional Site
                  </Grid2>
                ) : (
                  <Grid2 className={styles.FlexboxlinearProgress}>
                    <Grid2 className={styles.Flexbox}>
                      <Grid2 className={styles.sitesCount}>
                        Additional Site ({availablity})
                      </Grid2>
                      <Grid2 className={styles.usedCount}>
                        {additionalSiteUsed} used
                      </Grid2>
                    </Grid2>
                    <Grid2
                      className={`${styles.linearProgress} ${
                        isLimitReached ? styles.width50 : ""
                      }`}
                    >
                      <LinearProgress
                        variant="determinate"
                        value={additionalSiteValue}
                        sx={{
                          width: "100%",
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#ccc",
                          "& .MuiLinearProgress-bar": {
                            background: reachedLimit
                              ? "linear-gradient(90deg, #E5B0B0 -3.88%, #EE0126 100%);"
                              : "linear-gradient(90deg, #135FC2 -3.88%, #EE3938 168.99%)",
                          },
                          "@media (min-width: 1800px)": {
                            height: "7px",
                          },
                        }}
                      />
                    </Grid2>
                  </Grid2>
                )}
              </>
            )} */}
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
